module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"titles":{"exploreOurServices":"Explore our services","complianceStatus":"Compliance status","pendingTasks":"Pending tasks"},"dialogs":{"welcome":{"title":"Welcome to Nation.better","description":"Please help us set up your account by answering the questions that follow."},"success":{"title":"Thank you!","description":"Our team will reach out to you soon."}}}}')
  delete Component.options._Ctor
}
